import { createContext } from 'react';

const knowledgeBaseContext = createContext();

export default knowledgeBaseContext;
